import {ThunkMiddleware} from '@reduxjs/toolkit'

import {PAY_HOME, PAY_HOME_M} from '@web/core/urls'
import {changeBrowserLocation, goBack} from '@web/helpers/browser'
import {isMobileDisplay} from '@web/helpers/userAgent'

import {orderInterrupted} from './actions'

const orderInterruptedCreator =
    <AppState>(): ThunkMiddleware<AppState> =>
    () =>
    (next) =>
    (action) => {
        /** orderInterrupted 액션 처리 */
        if (orderInterrupted.match(action)) {
            action.payload.forEach((payload) => {
                switch (payload.type) {
                    case 'ALERT':
                        window.alert(payload.message)
                        break
                    case 'POPUP':
                        window.open(...payload.props)
                        break
                    case 'REDIRECT': {
                        if (payload.push && payload.url) {
                            changeBrowserLocation({
                                url: payload.url,
                                type: 'PUSH',
                            })
                        } else {
                            const payHomeUrl = isMobileDisplay ? PAY_HOME_M : PAY_HOME
                            /** 주문서를 요청했던 페이지로 되돌려보냅니다 */
                            changeBrowserLocation({
                                url: payload.url ?? payHomeUrl,
                                type: 'REPLACE',
                            })
                        }
                        break
                    }
                    case 'CLOSE':
                        if (payload.timer) {
                            setTimeout(() => {
                                window.self.close()
                            }, payload.timer)
                        }
                        window.self.close()
                        break
                    case 'BACK':
                        goBack({history: window.history})
                        if (payload.shouldClose) {
                            setTimeout(() => {
                                window.self.close()
                            }, 300)
                        }
                        break
                    default: {
                        const exhaustiveCheck: never = payload
                        throw new Error(exhaustiveCheck)
                    }
                }
            })
        }

        next(action)
    }

export default orderInterruptedCreator
